<template>
    <div class="footer">
        <div class="footer-t">
                <div class="wx-info">
                    <div class="wx-icon">
                        <img src="../../../assets/img/customer/weixin.svg" alt="">
                    </div>
                    <div class="wx-tip">
                        <p>关注公众号</p>
                        <p>获取业务进度提醒</p>
                    </div>
                    <div class="wx-erweima">
                        <img src="../../../assets/img/customer/erweima.jpg" alt="">
                    </div>
                </div>
                <div class="contact-info">
                    <div class="sec">
                        <div class="title"><img src="/static/lianxi.png" alt=""><span>咨询热线：</span></div>
                        <div class="desc">4006004006</div>
                    </div>
                    <div class="sec">
                        <div class="title"><img src="/static/dizhi.png" alt=""><span>联系地址：</span></div>
                        <div class="desc">北京市西城区华远北街2号通港大厦6层</div>
                    </div>
                </div>
                <div class="contact-info">
                    <div class="sec">
                        <div class="title"><img src="/static/emil.png" alt=""><span>安全响应邮箱:</span></div>
                        <div class="desc">security@cloud-link.com</div>
                    </div>
                </div>
        </div>
        <div class="footer-b">
            <div class="f-b1">Copyright©2021 cloud-link.All Rights Reserved.北京云链金汇数字科技有限公司 版权所有</div>
            <div class="f-b2">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009376" target="_blank">
                    <img src="/static/gongan.png">
                    <span>京公网安备 11010202009376号</span>
                </a>
            </div>
            <div class="f-b3"><a href="http://beian.miit.gov.cn" target="_blank">京ICP备2021007762号</a></div>
        </div>
    </div>
</template>
<script>
export default {
	name: 'gylfooter',
	props: {
        act:{
            type:String,
            default:''
        },
	},
	data() {
		return {
            topFixed:false,
            scrollTop:null
		}
    },
	created(){
        // if(this.$store.state.menu.scroll>375){//解决滚动后再点击切换其他tab的bug，且必须写在created里避免闪烁
        //     this.topFixed = true;
        // }else{
        //     this.topFixed = false;
        // }
    },
    mounted(){
        //window.addEventListener('scroll',this.handleScroll)
    },
	methods: {
        // handleScroll(e){
        //     this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        //     this.$store.commit("setScroll",this.scrollTop);
        //     if(this.$store.state.menu.scroll>375){
        //         this.topFixed = true;
        //     }else{
        //         this.topFixed = false;
        //     }
        // },
        // zhwy(){
        //     window.location.href='https://ebsnew.boc.cn/boccp/login.html?entryType=9';
        // }
	}
}
</script>
<style lang="less" scoped>
.footer {
    position: relative;
    color: #fff;
    .footer-t{
        overflow: hidden;
        background-color: #34373C;
        margin: 0 auto;
        display: flex;
        padding: 30px 0;
        justify-content: center;
            .wx-info{
                display: flex;
                margin-right: 280px;
                .wx-icon{
                    width:50px;
                    img{
                        width: 100%;
                    }
                }
                .wx-tip{
                    margin: 0 20px;
                    p{
                        padding: 5px 0;
                    }
                }
                .wx-erweima{
                    width: 115px;
                    img{
                        width:100%;
                    }
                }
            }
            .contact-info{
                .sec{
                    &:first-child{
                        margin-bottom: 18px;
                    }
                    .title{
                        img{width:15px;vertical-align: middle;margin-right: 10px;}
                        span{vertical-align: middle}
                    }
                    .desc{
                        font-size: 18px;
                        margin-top: 7px;
                    }
                }
            }
    }

    .footer-b{
        margin: 0 auto;
        background-color: rgba(85, 85, 85, 1);
        /*height: 41px;*/
        padding: 13px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .f-b1{
            margin-right: 80px;
        }
        .f-b2{
            margin-right: 30px;
            a {
                display: block;
                color:#fff;
                outline: none;
                img{
                    vertical-align: middle;
                }
                span{
                    vertical-align: middle;
                }
            }
        }
        .f-b3{
            a{
                color:#fff;
                outline: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/inc/component/gyl-footer.vue